<template>
    <div class="card">
        <template v-if="link">
            <router-link :to="link">
                <div v-if="title" class="card-header">
                    {{ title }}
                </div>
                <img v-if="img" :src="img" class="card-img-top">
            </router-link>
        </template>

        <template v-else="link">
            <div v-if="title" class="card-header">
                {{ title }}
            </div>
            <img v-if="img" :src="img" class="card-img-top">
        </template>

        <div class="card-body">
            <slot/>
        </div>

        <div class="card-footer" v-if="hasFooterSlot">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Card',

        props: {
            title: {type: String, default: null},
            img: {type: String, default: null},
            link: {type: Object, default: null}
        },

        computed: {
            hasFooterSlot() {
                return !!this.$slots['footer']
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Card.vue